<template>
    <div class="member_and" v-if="showIf">
        <top :Info="Info"></top>
        <meal 
            :Info="Info" 
            source="and" 
            v-if="!Info.needUpgrade"
            ref="meal"
        ></meal>
        <meal-update 
            :Info="Info" 
            source="and" 
            v-if="Info.needUpgrade"
            ref="mealUpdate"
        ></meal-update>
        <agreement source="and"></agreement>
        <quan-yi source="and"></quan-yi>
        <no-pay-pop-up 
            :needUpgrade='Info.needUpgrade'
            v-if="showFailToast"
            @close="closePop"
            @pay="goPay"
        ></no-pay-pop-up>
    </div>
</template>

<script>
import ajax from "@/api/memberAjax.js";
import utils from "@/assets/js/utils";
import NoPayPopUp from "./no_pay_popup";
import Top from "./member_top";
import Meal from "./member_meal";
import MealUpdate from "./member_update_meal";
import QuanYi from "./member_quanyi";
import Agreement from "./member_agreement";
const token = utils.getQueryString('token');
const version = utils.getQueryString('version');
const source = utils.getQueryString('source');
const categoryId = utils.getQueryString('categoryId');
const pageChannelId = utils.getQueryString('pageChannel');
const productId = utils.getQueryString('productId');    //商品Id

var vm = null;
window.jsCallback = function(res) {
    if(res == 'cancel') {
        vm.showFailToast = true;
    }else {
        if(window.goAddress) window.location.href = '/#/address?version=' + version + '&token=' + token + '&source=' + source
        else window.location.href = 'hybird://method/exit';
    }
}

export default {
    name: "",
    components: {
        NoPayPopUp,
        Top,
        Meal,
        MealUpdate,
        QuanYi,
        Agreement
    },
    data() {
        return {
            showFailToast: false,       // 支付取消、失败弹框
            showIf: false,
            Info: {
                memberInfo: {
                    isMember: 1, // 是否是会员 1是 0否
                    username: "xxx",
                    memberDesc: "开通会员 全场免费学",// 会员信息描述
                },
                needUpgrade: 1,// 是否升级,1是 0否,如果是1时
                superMember: 12,// 超级会员时间,单位天
                syncTest: 124,// 同步练会员时间,单位天
                freeDays: 123,// 升级时免费天数
                memberProductList:[ // needUpgrade=1时此字段只有升级对应产品
                    {
                        "productId": 993,// 产品id
                        "title": "连续包月",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":1,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":0,// 是否有价格比对
                    },
                    {
                        "productId": 994,// 产品id
                        "title": "连续包月",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":0,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":1,// 是否有价格比对
                    },
                    {
                        "productId": 995,// 产品id
                        "title": "连续包月",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":0,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":0,// 是否有价格比对
                    },
                    {
                        "productId": 996,// 产品id
                        "title": "连续包月",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":0,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":0,// 是否有价格比对
                    },
                    {
                        "productId": 997,// 产品id
                        "title": "连续包月",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":0,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":0,// 是否有价格比对
                    },
                ]
            }
        }
    },
    methods: {
        async getInfo() {
            const [resp] = await ajax.all([
                ajax.get('/pay/common/member-sale-page', {
                    params: {
                        token,
                        version,
                        source
                    }   
                })
            ])
            if(resp.data.code == 99999){
                console.log(resp.data);
                this.Info = resp.data.data;
                this.showIf = true;
                if(this.Info.needUpgrade){
                    gio('track', 'vipUpdatePage_show', this.getGioParams());
                    utils.sendLog({
                        token,
                        version,
                        source,
                        extensionJson: this.getGioParams()
                    }, 'hzxx912')
                }else{
                    gio('track', 'vipOpenPgae_show', this.getGioParams());
                    utils.sendLog({
                        token,
                        version,
                        source,
                        extensionJson: this.getGioParams()
                    }, 'hzxx910')
                }
            }
        },
        closePop() {
            this.showFailToast = false;
        },
        goPay() {
            this.Info.needUpgrade ? this.$refs.mealUpdate.goPay('cancelPop') : this.$refs.meal.goPay('cancelPop');    
        },
        getGioParams(){
            return {
                categoryId,
                pageChannelId,
                isVip: this.Info.memberInfo.isMember,
                productId,
            }
        }
    },
    created() {
        this.getInfo(); 

        vm = this;
        
    }
}
</script>

<style lang="scss" scoped>

.member_and {
    text-align: center;
    font-family: PingFangSC-Medium;
    
    .quanyi {

    }

}
</style>